import React, { useState, useEffect } from "react"
import { Navigate } from "react-router-dom"
import moment from "moment"

import { Col, Card, CardBody, Container, Row, Button } from "reactstrap"
import api from "../../services/api"
import { useForm } from "react-hook-form"
import Swal from "sweetalert2"
import Input from "components/shared/Inputs/Inputs"
import AuthService from "../../services/Auth.service"
import { HiOutlineQuestionMarkCircle } from "react-icons/hi"
import relojiodemo from "../../assets/images/relojiodemo.jpeg"
import "./tool.css"
import ExcelJS from "exceljs"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import {
  getConsumoDaLinha,
  getConsumoPeriodoTotal,
  getLeituraAtualDaLinha,
  getLitrosDaLinha,
  getM3DaLinha,
} from "./consumoCalculations"
// import ReactExport from "react-export-excel";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import "./datatables.scss"

import Select from "react-select"
import CondominioSelect, {
  empresasToSelectOptions,
} from "../../components/Empresa/CondominioSelect"

// true = admin (DS_STATUS 10) vê a mesma tela avançada do síndico
const ADMIN_USES_SYNDIC_CONSUMO_VIEW = false

// Uma única requisição: paginar com OFFSET refaz a query pesada a cada página (~12s+)
const REGISTRO_FETCH_LIMIT = 50000

async function fetchAllRegistros(body) {
  const { data } = await api.post(
    "/consumptions/registro",
    {
      ...body,
      limit: REGISTRO_FETCH_LIMIT,
      offset: 0,
    },
    { timeout: 120000 },
  )
  const all = Array.isArray(data) ? data : []
  if (all.length >= REGISTRO_FETCH_LIMIT) {
    console.warn(
      `[Consumo] Limite de ${REGISTRO_FETCH_LIMIT} leituras atingido; refine o período ou o medidor.`,
    )
  }
  return all
}

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Consumo = () => {
  const initialState = {
    maker: "",
    desc: "",
    model: "",
    number: "",
  }

  const initialState2 = {
    pri: "0",
    seg: "0",
    ter: "0",
    qua: "0",
    qui: "0",
    sex: "0",
    set: "0",
  }

  const statereloj = {
    reloj: "0000000",
    reloj7: "",
  }
  const [relojio, setRelojio] = useState(initialState2)
  const [relojiod, setRelojiod] = useState(statereloj)

  function padWithLeadingZeros(num, totalLength) {
    return String(num).padStart(totalLength, "0")
  }

  const [isShowncd, setIsShowncd] = useState(false)

  const Empresa = {
    OID_EMPRESA: "",
    NM_RAZAO_SOCIAL: "",
  }

  const [searchmd, setSearchMD] = useState([])
  const [currentReading, setCurrentReading] = useState("")
  const [currentMedidor, setCurrentMedidor] = useState("")
  const [select, setSelect] = useState(-1)
  const [isLoading, setIsLoading] = useState(false)
  const [isMedidor, setIsMedidor] = useState(false)

  const [selectedMed, setSelectedMed] = useState(null)
  const [selectedCond, setSelectedCond] = useState(null)

  let stateempresa = null

  const user = AuthService.getCurrentUser()

  let checkempresa = null
  let DS_STATUS = null
  if (user != null) {
    DS_STATUS = user.user.DS_STATUS
    if (user.empresa[0] != undefined) {
      checkempresa = user.empresa[0].OID_EMPRESA
    }
  }

  const statusNumber =
    DS_STATUS === null || DS_STATUS === undefined ? null : Number(DS_STATUS)
  const isSyndicProfile = statusNumber === 1
  const isAdminProfile = statusNumber === 10
  const isMoradorProfile =
    AuthService.isMorador(user) || statusNumber === 2
  const usesSyndicConsumptionView =
    isSyndicProfile || (ADMIN_USES_SYNDIC_CONSUMO_VIEW && isAdminProfile)

  const [consumptions, setConsumptions] = useState([])
  const [consumptionsForTotal, setConsumptionsForTotal] = useState([])
  const [pulses, setPulses] = useState([])

  let [lc, setLc] = useState(Empresa)

  const [search, setSearch] = useState(initialState)
  let [makers, setMakers] = useState([])
  const [condos, setCondo] = useState([])

  const { register, handleSubmit, watch } = useForm({
    defaultValues: {
      DT_FILTER_INI: moment().startOf("month").format("YYYY-MM-DD"),
      DT_FILTER_FIM: moment().format("YYYY-MM-DD"),
    },
  })

  const dtIni = watch("DT_FILTER_INI")
  const dtFim = watch("DT_FILTER_FIM")

  const applyLeituraFromConsumo = consumption => {
    if (!consumption) {
      setCurrentMedidor("")
      setCurrentReading(0)
      return
    }
    const leitura = Number(
      consumption.NR_LEITURA_ATUAL ?? getLeituraAtualDaLinha(consumption),
    )
    setCurrentMedidor(consumption.NR_HIDROMETRO_IMOVEL || "")
    setCurrentReading(Number.isFinite(leitura) ? Math.trunc(leitura) : 0)
  }

  useEffect(() => {
    const value = padWithLeadingZeros(
      Math.trunc(Number(currentReading) || 0).toString(),
      7,
    )
    setRelojiod({ reloj: value })

    setRelojio({
      set: value.charAt(value.length - 1),
      sex: value.charAt(value.length - 2),
      qui: value.charAt(value.length - 3),
      qua: value.charAt(value.length - 4),
      ter: value.charAt(value.length - 5),
      seg: value.charAt(value.length - 6),
      pri: value.charAt(value.length - 7),
    })
  }, [currentReading])

  const isMedidorSelecionado = () =>
    !!(
      selectedMed &&
      selectedMed.value &&
      selectedMed.value !== "Selecione..." &&
      selectedMed.value !== ""
    )

  const fetchMakers = () => {
    let maker = [{ value: "", label: "Todos" }]
    api.get("/imovel/hidro/" + user.user.OID_USUARIO).then(response => {
      response.data.map(elem => {
        maker.push({
          value: elem.OID_MEDIDOR,
          label: "Medidor: " + elem.NR_MEDIDOR + " - " + elem.imovel,
        })
      })
      setMakers(maker)
      setSelectedMed(maker[0])
    })
  }

  const fetchCondo = async () => {
    if (isAdminProfile) {
      api.get("/empresa/").then(response => {
        const condo = empresasToSelectOptions(response.data)
        setCondo(condo)
        if (condo.length > 0) {
          const first = condo[0]
          setSelectedCond(first)
          fetchHidroCondo(first.value)
        }
      })
      return
    }

    const session = await AuthService.refreshEmpresas()
    const condo = empresasToSelectOptions(
      AuthService.getLinkedEmpresas(session),
    )
    setCondo(condo)
    if (condo.length > 0) {
      const first = condo[0]
      setSelectedCond(first)
      setLc({ ...lc, OID_EMPRESA: first.value })
      fetchHidroCondo(first.value)
    }
  }

  useEffect(() => {
    fetchMakers()
  }, [])

  useEffect(() => {
    if (isSyndicProfile || isAdminProfile) {
      fetchCondo()
    }
  }, [isSyndicProfile, isAdminProfile])

  const onChangeHandler = prop => event => {
    const selectedValue = event.target.value

    setSearch({ ...search, [prop]: selectedValue })

    // Check if the selected value is "Selecione..."
    if (selectedValue === "Selecione...") {
      // Reset the search.maker to an empty string or another default value
      setSearch({ ...search, [prop]: "" })
    }

    // Other logic you may have
  }

  const onChangeCondo = prop => event => {
    setLc({ ...lc, [prop]: event.target.value })

    stateempresa = event.target.value

    fetchHidroCondo()
  }
  const onChangeHandlerMed = selectedOption => {
    setSelectedMed(selectedOption)
    console.log("Selected Lora:", selectedOption.value)

    setSearch({ ...search, maker: selectedOption.value })

    // Check if the selected value is "Selecione..."
    if (selectedOption.value === "") {
      setSearch({ ...search, maker: "" })
    }
  }

  const onChangeHandlerCond = selectedOption => {
    if (selectedOption === null) {
      fetchMakers()
      setSelectedCond(null)
      setSelectedMed(null)
      setSearch({ ...search, maker: "" })
    } else {
      setSelectedCond(selectedOption)

      stateempresa = selectedOption.value

      if (selectedOption.value === "") {
        fetchMakers()
      } else {
        fetchHidroCondo()
      }
      console.log("Selected Lora:", selectedOption.value)
    }
  }

  const fetchHidroCondo = empresaId => {
    const id = empresaId || stateempresa
    let maker = [{ value: "", label: "Todos" }]
    if (!id) {
      setMakers(maker)
      setSelectedMed(maker[0])
      return
    }
    api.get("/imovel/empresa/" + id).then(response => {
      response.data.map(elem => {
        maker.push({
          value: elem.OID_MEDIDOR,
          label: "Medidor: " + elem.NR_MEDIDOR + " - " + elem.imovel,
        })
      })
      setMakers(maker)
      setSelectedMed(maker[0])
    })
  }

  const onSubmit = async data => {
    setIsMedidor(false)
    setSearchMD({ searched: false })
    setConsumptions([])
    setConsumptionsForTotal([])
    if (
      data.IDA === "" &&
      data.CD_META_DEVICE_ADDR === "" &&
      data.NR_MEDIDOR === "" &&
      data.DT_FILTER_INI === "" &&
      data.DT_FILTER_FIM === ""
    ) {
      Swal.fire({
        icon: "warning",
        text: "Por Favor Preencha ao Menos um Campo",
      })
      return
    }

    if (data.DT_FILTER_INI != "" && data.DT_FILTER_FIM != "") {
      if (data.DT_FILTER_INI > data.DT_FILTER_FIM) {
        Swal.fire({
          icon: "warning",
          text: "A data Fim não pode menor que a data Inicio",
        })
        return
      }
    }

    let body = {
      OID_MEDIDOR:
        selectedMed && selectedMed.value != "Selecione..."
          ? selectedMed.value
          : "",
      OID_CONDOMINIO: selectedCond ? selectedCond.value : checkempresa,
      DT_FILTER_INI: data.DT_FILTER_INI,
      DT_FILTER_FIM: data.DT_FILTER_FIM,
    }

    setIsLoading(true)
    setConsumptions([])

    try {
      const allData = await fetchAllRegistros(body)

      if (allData.length === 0) {
        setIsLoading(false)
        Swal.fire({
          icon: "warning",
          text: "Nenhum Registro encontrado para este Medidor",
        })
        return
      }

      setIsLoading(false)
      Swal.fire({
        icon: "success",
      })

      if (allData.length >= REGISTRO_FETCH_LIMIT) {
        console.warn(
          `[Consumo] ${allData.length} leituras (limite máximo); refine o filtro se faltarem dados`,
        )
      }

      const sortedData = allData.sort(
        (a, b) => new Date(b.DT_LEITURA) - new Date(a.DT_LEITURA),
      )

      const extractDateStr = item => {
        if (!item.DT_LEITURA) return ""
        const date = new Date(item.DT_LEITURA)
        return new Intl.DateTimeFormat("en-CA", {
          timeZone: "America/Sao_Paulo",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }).format(date)
      }

      let rawForTotal = [...sortedData]
      if (data.DT_FILTER_INI && data.DT_FILTER_FIM) {
        rawForTotal = rawForTotal.filter(item => {
          const itemDateStr = extractDateStr(item)
          return (
            itemDateStr >= data.DT_FILTER_INI &&
            itemDateStr <= data.DT_FILTER_FIM
          )
        })
      }
      // Leituras brutas (antes do agrupamento diário) — base do total do período
      setConsumptionsForTotal(
        rawForTotal.map(item => ({
          ...item,
          NR_LEITURA_ATUAL: getLeituraAtualDaLinha(item),
        })),
      )

      if (!usesSyndicConsumptionView) {
        const dataToProcess = sortedData

        let result = dataToProcess.map((consumption, i) => {
          const currentPulse = Math.trunc(Number(consumption.NR_PULSO || 0))
          const nextPulse = Math.trunc(
            Number(dataToProcess[i + 1]?.NR_PULSO || currentPulse),
          )
          const pulseDiff = Math.max(0, currentPulse - nextPulse)
          const litersPerPulse = Number(consumption.VR_LITROS_POR_PULSO || 0)
          const litersByPulse = pulseDiff * litersPerPulse
          const litros = litersByPulse

          return {
            ...consumption,
            i,
            NR_MEDIDOR: consumption.NR_HIDROMETRO_IMOVEL,
            DS_MODELO_MEDIDOR: consumption.DS_MODELO_MEDIDOR,
            DS_LOCALIDADE: consumption.DS_LOCALIDADE,
            RELOJOARIA: consumption.RELOJOARIA,
            NR_DIFERENCA_CONSUMO: pulseDiff,
            NR_LITROS_CONSUMO: litros,
            NR_QUANTIDADE_LITROSMC: litros / 1000,
            NR_LEITURA_ATUAL: getLeituraAtualDaLinha(consumption),
            DT_RX_TIMED: new Date(consumption.DT_LEITURA).toLocaleDateString(
              "pt-BR",
              {
                timeZone: "America/Sao_Paulo",
              },
            ),
            DT_RX_TIMEH: new Date(consumption.DT_LEITURA).toLocaleTimeString(
              "pt-BR",
              {
                timeZone: "America/Sao_Paulo",
              },
            ),
          }
        })

        if (data.DT_FILTER_INI && data.DT_FILTER_FIM) {
          result = result.filter(item => {
            const itemDateStr = extractDateStr(item)
            return (
              itemDateStr >= data.DT_FILTER_INI &&
              itemDateStr <= data.DT_FILTER_FIM
            )
          })
        }

        setConsumptions(result)
        const medidorOk = isMedidorSelecionado()
        setIsMedidor(medidorOk)
        if (medidorOk && result.length > 0) {
          applyLeituraFromConsumo(result[0])
        } else {
          setCurrentMedidor("")
          setCurrentReading(0)
        }
        setSearchMD({ searched: true })
        return
      }

      // Fluxo síndico: processa TODO o dataset (sem slice)
      const dataToProcess = sortedData

      const sortedForCalc = [...dataToProcess].sort((a, b) => {
        const medidorCompare = (a.NR_HIDROMETRO_IMOVEL || "").localeCompare(
          b.NR_HIDROMETRO_IMOVEL || "",
        )
        if (medidorCompare !== 0) return medidorCompare

        const compCompare = (a.DS_COMPLEMENTO_IMOVEL || "").localeCompare(
          b.DS_COMPLEMENTO_IMOVEL || "",
        )
        if (compCompare !== 0) return compCompare

        const dateA = new Date(a.DT_LEITURA)
        const dateB = new Date(b.DT_LEITURA)
        return dateA - dateB
      })

      const leiturasComLitros = sortedForCalc.map((item, i, arr) => {
        const prevItem = arr[i - 1]
        let litros = 0

        if (
          prevItem &&
          prevItem.NR_HIDROMETRO_IMOVEL === item.NR_HIDROMETRO_IMOVEL &&
          prevItem.DS_COMPLEMENTO_IMOVEL === item.DS_COMPLEMENTO_IMOVEL
        ) {
          const pulsoAtual = Number(item.NR_PULSO || 0)
          const pulsoAnterior = Number(prevItem.NR_PULSO || 0)

          let diffPulso = Math.trunc(pulsoAtual) - Math.trunc(pulsoAnterior)
          if (diffPulso < 0) diffPulso = 0

          const vlPulso =
            typeof item.VR_LITROS_POR_PULSO === "number" &&
            item.VR_LITROS_POR_PULSO > 0
              ? item.VR_LITROS_POR_PULSO
              : 1
          litros = diffPulso * vlPulso
        }

        return { ...item, _litrosCalculado: litros }
      })

      const groupedData = {}

      leiturasComLitros.forEach(item => {
        const dateStr = extractDateStr(item)
        const key = `${item.NR_HIDROMETRO_IMOVEL}-${item.DS_COMPLEMENTO_IMOVEL}-${dateStr}`

        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            _litrosDia: item._litrosCalculado,
            _registrosDia: 1,
          }
        } else {
          groupedData[key]._litrosDia += item._litrosCalculado
          groupedData[key]._registrosDia += 1
          if (new Date(item.DT_LEITURA) > new Date(groupedData[key].DT_LEITURA)) {
            const litrosAcumulados = groupedData[key]._litrosDia
            const registrosAcumulados = groupedData[key]._registrosDia
            groupedData[key] = {
              ...item,
              _litrosDia: litrosAcumulados,
              _registrosDia: registrosAcumulados,
            }
          }
        }
      })

      let uniqueDailyRecords = Object.values(groupedData)

      uniqueDailyRecords.sort((a, b) => {
        const medidorCompare = (a.NR_HIDROMETRO_IMOVEL || "").localeCompare(
          b.NR_HIDROMETRO_IMOVEL || "",
        )
        if (medidorCompare !== 0) return medidorCompare

        const compCompare = (a.DS_COMPLEMENTO_IMOVEL || "").localeCompare(
          b.DS_COMPLEMENTO_IMOVEL || "",
        )
        if (compCompare !== 0) return compCompare

        const dateA = new Date(a.DT_LEITURA)
        const dateB = new Date(b.DT_LEITURA)
        return dateB - dateA
      })

      let result = uniqueDailyRecords.map((item, i, arr) => {
        const prevItem = arr[i - 1]

        const isLeituraAtualMedidor =
          !prevItem ||
          prevItem.NR_HIDROMETRO_IMOVEL !== item.NR_HIDROMETRO_IMOVEL ||
          prevItem.DS_COMPLEMENTO_IMOVEL !== item.DS_COMPLEMENTO_IMOVEL

        const leituraAtual = getLeituraAtualDaLinha(item)
        const litros = item._litrosDia || 0
        const m3 = litros / 1000

        return {
          ...item,
          i: i,
          NR_MEDIDOR: item.NR_HIDROMETRO_IMOVEL,
          DS_MODELO_MEDIDOR: item.DS_MODELO_MEDIDOR,
          DS_LOCALIDADE: item.DS_LOCALIDADE,
          RELOJOARIA: item.RELOJOARIA,
          NR_DIFERENCA_CONSUMO: litros,
          NR_QUANTIDADE_LITROSMC: m3,
          NR_LITROS_CONSUMO: litros,
          IS_LEITURA_ATUAL: isLeituraAtualMedidor,
          NR_LEITURA_ATUAL: leituraAtual,
          DT_RX_TIMED: new Date(item.DT_LEITURA).toLocaleDateString("pt-BR", {
            timeZone: "America/Sao_Paulo",
          }),
          DT_RX_TIMEH: new Date(item.DT_LEITURA).toLocaleTimeString("pt-BR", {
            timeZone: "America/Sao_Paulo",
          }),
        }
      })

      result.sort((a, b) => {
        const dateA = new Date(a.DT_LEITURA).getTime()
        const dateB = new Date(b.DT_LEITURA).getTime()
        if (dateA !== dateB) return dateB - dateA
        return (a.NR_MEDIDOR || "").localeCompare(b.NR_MEDIDOR || "")
      })

      if (data.DT_FILTER_INI && data.DT_FILTER_FIM) {
        result = result.filter(item => {
          if (!item.DT_LEITURA) return false
          const date = new Date(item.DT_LEITURA)
          const itemDateStr = new Intl.DateTimeFormat("en-CA", {
            timeZone: "America/Sao_Paulo",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }).format(date)

          return (
            itemDateStr >= data.DT_FILTER_INI &&
            itemDateStr <= data.DT_FILTER_FIM
          )
        })
      }

      setConsumptions(result)
      const medidorOk = isMedidorSelecionado()
      setIsMedidor(medidorOk)
      if (medidorOk && result.length > 0) {
        applyLeituraFromConsumo(result[0])
      } else {
        setCurrentMedidor("")
        setCurrentReading(0)
      }
      setSearchMD({ searched: true })
    } catch (error) {
      setIsLoading(false)
      setConsumptionsForTotal([])
      console.log(error)
      Swal.fire({
        icon: "warning",
        text: "Nenhum resultado encontrado, refaça a sua busca!",
      })
    }
  }

  const handleDownload = async () => {
    const workbook = new ExcelJS.Workbook()
    const sheet = workbook.addWorksheet("Consumos")

    if (!usesSyndicConsumptionView) {
      sheet.columns = [
        { header: "Nr. Medidor", key: "medidor", width: 20 },
        { header: "Imóvel", key: "imovel", width: 25 },
        { header: "Condomínio", key: "condominio", width: 30 },
        { header: "Data", key: "data", width: 15 },
        { header: "Hora", key: "hora", width: 15 },
        { header: "Nr. Pulso", key: "pulso", width: 15 },
        { header: "Vr. Pulso Medidor", key: "vr_pulso", width: 20 },
        { header: "Litros", key: "litros", width: 15 },
        { header: "Diferença/Consumo", key: "consumo", width: 20 },
      ]

      sheet.getRow(1).eachCell(cell => {
        cell.font = { bold: true }
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFD9D9D9" },
        }
      })

      consumptions.forEach(item => {
        const litrosLinha = getLitrosDaLinha(item, isSyndicProfile)
        const consumoLinha = getConsumoDaLinha(item)
        sheet.addRow({
          medidor: item.NR_HIDROMETRO_IMOVEL,
          imovel: item.DS_COMPLEMENTO_IMOVEL,
          condominio: item.NM_RAZAO_SOCIAL,
          data:
            item.DT_RX_TIMED ||
            new Date(item.DT_LEITURA).toLocaleDateString("pt-BR", {
              timeZone: "America/Sao_Paulo",
            }),
          hora:
            item.DT_RX_TIMEH ||
            new Date(item.DT_LEITURA).toLocaleTimeString("pt-BR", {
              timeZone: "America/Sao_Paulo",
            }),
          pulso: item.NR_PULSO,
          vr_pulso: item.VR_LITROS_POR_PULSO,
          litros: Number(litrosLinha.toFixed(2)),
          consumo: Number(consumoLinha.toFixed(2)),
        })
      })

      const totalConsumoPeriodoUnidades = getConsumoPeriodoTotal(
        consumptionsForTotal,
      )
      const totalConsumoPeriodoM3 = totalConsumoPeriodoUnidades / 1000

      sheet.addRow({})
      const totalRow = sheet.addRow({
        medidor: "TOTAIS",
        litros: Number(totalConsumoPeriodoUnidades.toFixed(2)),
        consumo: Number(totalConsumoPeriodoUnidades.toFixed(2)),
        condominio: `Período: ${totalConsumoPeriodoM3.toFixed(3)} m³`,
      })
      totalRow.font = { bold: true }

      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      })

      const url = URL.createObjectURL(blob)
      const a = document.createElement("a")
      a.href = url
      a.download = "Consumo.xlsx"
      a.click()
      URL.revokeObjectURL(url)
      return
    }

    sheet.columns = [
      { header: "Nr. Medidor", key: "medidor", width: 20 },
      { header: "Imóvel", key: "imovel", width: 25 },
      { header: "Condomínio", key: "condominio", width: 30 },
      { header: "Data", key: "data", width: 15 },
      { header: "Hora", key: "hora", width: 15 },
      { header: "Litros", key: "litros", width: 15 },
      { header: "Metro cúbico (m³)", key: "m3", width: 20 },
      { header: "Leitura atual", key: "leitura_atual", width: 20 },
    ]

    sheet.getRow(1).eachCell(cell => {
      cell.font = { bold: true }
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFD9D9D9" }, // cinza claro
      }
    })

    const totalConsumoPeriodoUnidades = getConsumoPeriodoTotal(
      consumptionsForTotal,
    )
    const totalConsumoPeriodoM3 = totalConsumoPeriodoUnidades / 1000

    consumptions.forEach(item => {
      const litros = getLitrosDaLinha(item, usesSyndicConsumptionView)
      const m3 = getM3DaLinha(item, usesSyndicConsumptionView)
      const leituraAtual = item.NR_LEITURA_ATUAL || 0

      sheet.addRow({
        medidor: item.NR_HIDROMETRO_IMOVEL,
        imovel: item.DS_COMPLEMENTO_IMOVEL,
        condominio: item.NM_RAZAO_SOCIAL,
        data: new Date(item.DT_LEITURA).toLocaleDateString("pt-BR", {
          timeZone: "America/Sao_Paulo",
        }),
        hora: new Date(item.DT_LEITURA).toLocaleTimeString("pt-BR", {
          timeZone: "America/Sao_Paulo",
        }),
        litros: Number(litros.toFixed(2)),
        m3: Number(m3.toFixed(3)),
        leitura_atual: leituraAtual,
      })
    })

    sheet.addRow({})

    // TOTAIS = consumo do período (delta por medidor), igual ao painel — não soma das linhas
    const totalRow = sheet.addRow({
      medidor: "TOTAIS",
      litros: Number(totalConsumoPeriodoUnidades.toFixed(2)),
      m3: Number(totalConsumoPeriodoM3.toFixed(3)),
      leitura_atual: `Diferença/Consumo: ${totalConsumoPeriodoM3.toFixed(3)} m³`,
    })
    totalRow.font = { bold: true }

    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })

    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = "Consumo.xlsx"
    a.click()
    URL.revokeObjectURL(url)
  }

  // Painel: delta min→max nas leituras brutas do período (não nas linhas diárias)
  const totalConsumptionM3 =
    getConsumoPeriodoTotal(consumptionsForTotal) / 1000

  let formatted = totalConsumptionM3.toFixed(3).padStart(7, "0")
  formatted = formatted.split(".")
  const blackPart = formatted[0]
  const redPart = formatted[1]
  const unit = "m³"

  useEffect(() => {
    // This code runs when dtIni or dtFim changes
    setSearchMD({ searched: false })
  }, [dtIni, dtFim]) // Dependency array

  // Morador (DS_STATUS 2) não acessa a tela completa de Consumo —
  // o relatório da unidade fica no dashboard ("Minha unidade").
  if (isMoradorProfile) {
    return <Navigate to="/" replace />
  }

  if (!usesSyndicConsumptionView) {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <div className="page-title-box">
              <Row className="align-items-center">
                <Col md={8}>
                  <label id="component-title">Consumo</label>
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item active"></li>
                  </ol>
                </Col>
              </Row>
            </div>
          </Container>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={8}>
                      <form onSubmit={handleSubmit(onSubmit)}>
                        {isAdminProfile && (
                          <Row className="mb-3">
                            <label
                              htmlFor="Condominio"
                              className="col-md-3 col-form-label"
                            >
                              Condomínio
                            </label>
                            <div
                              className="col-md-9"
                              style={{ textAlign: "start" }}
                            >
                              <CondominioSelect
                                inputId="Condominio"
                                onChange={onChangeHandlerCond}
                                isDisabled={isLoading}
                                options={condos}
                                value={selectedCond}
                                isClearable
                              />
                            </div>
                          </Row>
                        )}

                        <Row className="mb-3">
                          <label
                            htmlFor="NR_MEDIDOR"
                            className="col-md-3 col-form-label"
                          >
                            Medidor
                          </label>
                          <div
                            className="col-md-9"
                            style={{ textAlign: "start" }}
                          >
                            <Select
                              placeholder="Selecione..."
                              onChange={onChangeHandlerMed}
                              isDisabled={isLoading}
                              styles={{
                                container: provided => ({
                                  ...provided,
                                  minWidth: "245px",
                                }),
                                menu: provided => ({
                                  ...provided,
                                  backgroundColor: "white",
                                  color: "black",
                                }),
                              }}
                              options={makers}
                              value={selectedMed}
                            />
                          </div>
                        </Row>

                        <Row className="mb-3">
                          <label
                            htmlFor="DT_FILTER_INI"
                            className="col-md-3 col-form-label"
                          >
                            Data Início
                          </label>
                          <div className="col-md-9">
                            <input
                              {...register("DT_FILTER_INI", {
                                required: false,
                              })}
                              className="form-control form-control-lg"
                              type="date"
                              name="DT_FILTER_INI"
                              defaultValue=""
                              disabled={isLoading}
                            />
                          </div>
                        </Row>

                        <Row className="mb-3">
                          <label
                            htmlFor="DT_FILTER_FIM"
                            className="col-md-3 col-form-label"
                          >
                            Data Final
                          </label>
                          <div className="col-md-9">
                            <input
                              {...register("DT_FILTER_FIM", {
                                required: false,
                              })}
                              className="form-control form-control-lg"
                              type="date"
                              name="DT_FILTER_FIM"
                              defaultValue=""
                              disabled={isLoading}
                            />
                          </div>
                        </Row>
                      </form>
                    </Col>

                    <Col md={4}>
                      <div
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          padding: "20px",
                          textAlign: "center",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          backgroundColor: "#f8f9fa",
                        }}
                      >
                        <h5 className="mb-3">
                          Valor total de consumo no período (m³)
                        </h5>
                        <p
                          className="text-muted mb-3"
                          style={{ fontSize: "14px" }}
                        >
                          Soma de todos os APTOs
                          <br />
                          {dtIni && dtFim
                            ? `Período: ${dtIni
                                .split("-")
                                .reverse()
                                .join("/")} - ${dtFim
                                .split("-")
                                .reverse()
                                .join("/")}`
                            : "(Selecione as datas)"}
                        </p>
                        {isLoading ? (
                          <i
                            className="mdi mdi-spin mdi-loading"
                            style={{ fontSize: "30px" }}
                          ></i>
                        ) : (
                          <div
                            style={{
                              fontSize: "28px",
                              fontWeight: "bold",
                              color: "#333",
                            }}
                          >
                            <span style={{ color: "black" }}>{blackPart}</span>
                            <span style={{ color: "red" }}>{redPart}</span>
                            <span
                              style={{
                                color: "black",
                                marginLeft: "5px",
                              }}
                            >
                              {unit}
                            </span>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>

                  <div className="col-md-12 mt-4 text-center">
                    <div className="text-center">
                      {isLoading ? (
                        <i
                          className="mdi mdi-spin mdi-loading"
                          style={{ fontSize: "50px" }}
                        ></i>
                      ) : (
                        <Button
                          color="secondary"
                          className="btn-lg"
                          type="submit"
                          onClick={handleSubmit(onSubmit)}
                        >
                          Pesquisar <i className="dripicons-search" />
                        </Button>
                      )}
                    </div>
                  </div>

                  {searchmd.searched && isMedidor && (
                    <div className="col-md-12 mt-4 text-center leitura-atual-wrap">
                      <span>Medidor: {currentMedidor}</span>
                      <br />
                      <span style={{ fontWeight: "600" }}>
                        Leitura Atual
                        <span className="font20">
                          <HiOutlineQuestionMarkCircle
                            onMouseOver={() => setIsShowncd(true)}
                            onMouseOut={() => setIsShowncd(false)}
                          />
                        </span>
                      </span>
                      <br />
                      {isShowncd && (
                        <div className="box-left">
                          <img
                            className="leitura-demo-img"
                            src={relojiodemo}
                            alt="Demonstração do relógio (leitura)"
                          />
                        </div>
                      )}
                      <span style={{ color: "black" }}>{relojio?.pri}</span>
                      <span style={{ color: "black" }}>{relojio?.seg}</span>
                      <span style={{ color: "black" }}>{relojio?.ter}</span>
                      <span style={{ color: "black" }}>{relojio?.qua}</span>
                      <span style={{ color: "red" }}>{relojio?.qui}</span>
                      <span style={{ color: "red" }}>{relojio?.sex}</span>
                      <span style={{ color: "red" }}>{relojio?.set}</span>
                      <span>M³</span>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Container fluid>
            <Row>
              <Col lg={12}></Col>
              <Col lg={12}>
                {consumptions && consumptions.length > 0 && (
                  <Button
                    color="primary"
                    onClick={handleDownload}
                    disabled={isLoading}
                  >
                    Baixar Relatório
                  </Button>
                )}
              </Col>
            </Row>
            <div className="table-rep-plugin">
              <div
                className="table-responsive "
                style={{ maxHeight: "450px" }}
                data-pattern="priority-columns"
              >
                <Table className="table table-striped table-bordered  ">
                  <Thead className="">
                    <Tr>
                      <Th className="align-middle">Nr. Medidor</Th>
                      <Th className="align-middle">Imóvel</Th>
                      <Th className="align-middle">Condomínio</Th>
                      <Th className="align-middle">Data</Th>
                      <Th className="align-middle">Hora</Th>
                      <Th className="align-middle">Nr. Pulso </Th>
                      <Th className="align-middle">Vr. Pulso Medidor </Th>
                      <Th className="align-middle">Litros</Th>
                      {isMedidor ? (
                        <Th className="align-middle">Diferença/Consumo</Th>
                      ) : (
                        ""
                      )}
                      <Th className="align-middle mb-2">Alarme</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {consumptions?.map((consumption, key) => (
                      <Tr
                        onClick={() => {
                          setSelect(key)
                          applyLeituraFromConsumo(consumption)
                        }}
                        key={"_tr_" + key}
                      >
                        <Td>{consumption?.NR_HIDROMETRO_IMOVEL}</Td>
                        <Td>{consumption?.DS_COMPLEMENTO_IMOVEL}</Td>
                        <Td>{consumption?.NM_RAZAO_SOCIAL}</Td>
                        <Td>
                          {consumption.DT_RX_TIMED ||
                            new Date(consumption.DT_LEITURA).toLocaleDateString(
                              "pt-BR",
                              { timeZone: "America/Sao_Paulo" },
                            )}
                        </Td>
                        <Td>
                          {consumption.DT_RX_TIMEH ||
                            new Date(consumption.DT_LEITURA).toLocaleTimeString(
                              "pt-BR",
                              { timeZone: "America/Sao_Paulo" },
                            )}
                        </Td>
                        <Td>{consumption.NR_PULSO}</Td>
                        <Td>{consumption.VR_LITROS_POR_PULSO}</Td>
                        <Td>{getLitrosDaLinha(consumption, isSyndicProfile).toFixed(2)}</Td>
                        {isMedidor ? (
                          <Td style={{ textAlign: "center" }}>
                            {getConsumoDaLinha(consumption)}
                          </Td>
                        ) : (
                          ""
                        )}
                        <Td>
                          <span className="badge bg-danger bg-primary">
                            {consumption.NR_ALARME
                              ? consumption.NR_ALARME
                              : "N/A"}
                          </span>
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </div>
            </div>
          </Container>
        </div>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <label id="component-title">Consumo</label>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active"></li>
                </ol>
              </Col>
            </Row>
          </div>
        </Container>

        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Row>
                  {/* Inputs e botão - 70% */}
                  <Col md={8}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      {usesSyndicConsumptionView && (
                        <Row className="mb-3">
                          <label
                            htmlFor="Condominio"
                            className="col-md-3 col-form-label"
                          >
                            Condomínio
                          </label>
                          <div
                            className="col-md-9"
                            style={{ textAlign: "start" }}
                          >
                            <CondominioSelect
                              inputId="Condominio"
                              onChange={onChangeHandlerCond}
                              isDisabled={isLoading}
                              options={condos}
                              value={selectedCond}
                              isClearable
                            />
                          </div>
                        </Row>
                      )}

                      <Row className="mb-3">
                        <label
                          htmlFor="NR_MEDIDOR"
                          className="col-md-3 col-form-label"
                        >
                          Medidor
                        </label>
                        <div
                          className="col-md-9"
                          style={{ textAlign: "start" }}
                        >
                          <Select
                            placeholder="Selecione..."
                            onChange={onChangeHandlerMed}
                            isDisabled={isLoading}
                            styles={{
                              container: provided => ({
                                ...provided,
                                minWidth: "245px",
                              }),
                              menu: provided => ({
                                ...provided,
                                backgroundColor: "white",
                                color: "black",
                                zIndex: 9999,
                              }),
                            }}
                            options={makers}
                            value={selectedMed}
                          />
                        </div>
                      </Row>

                      <Row className="mb-3">
                        <label
                          htmlFor="DT_FILTER_INI"
                          className="col-md-3 col-form-label"
                        >
                          Data Início
                        </label>
                        <div className="col-md-9">
                          <input
                            {...register("DT_FILTER_INI", { required: false })}
                            className="form-control form-control-lg"
                            type="date"
                            name="DT_FILTER_INI"
                            defaultValue=""
                            disabled={isLoading}
                          />
                        </div>
                      </Row>

                      <Row className="mb-3">
                        <label
                          htmlFor="DT_FILTER_FIM"
                          className="col-md-3 col-form-label"
                        >
                          Data Final
                        </label>
                        <div className="col-md-9">
                          <input
                            {...register("DT_FILTER_FIM", { required: false })}
                            className="form-control form-control-lg"
                            type="date"
                            name="DT_FILTER_FIM"
                            defaultValue=""
                            disabled={isLoading}
                          />
                        </div>
                      </Row>

                      {/* <Row className="mb-3">
                <div className="text-center">
                  {isLoading ? (
                    <i className="mdi mdi-spin mdi-loading" style={{ fontSize: "50px" }}></i>
                  ) : (
                    <Button color="secondary" className="btn-lg" type="submit">
                      Pesquisar <i className="dripicons-search" />
                    </Button>
                  )}
                </div>
              </Row> */}
                    </form>
                  </Col>

                  {/* Box lateral - 30% */}
                  <Col md={4}>
                    <div
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        padding: "20px",
                        textAlign: "center",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        backgroundColor: "#f8f9fa",
                      }}
                    >
                      <h5 className="mb-3">
                        Valor total de consumo no período (m³)
                      </h5>

                      <p
                        className="text-muted mb-3"
                        style={{ fontSize: "14px" }}
                      >
                        Período selecionado
                        <br />
                        {dtIni && dtFim
                          ? `Últimos ${Math.round(
                              (new Date(dtFim) - new Date(dtIni)) /
                                (1000 * 60 * 60 * 24),
                            )} dias (${dtIni
                              .split("-")
                              .reverse()
                              .join("/")} - ${dtFim
                              .split("-")
                              .reverse()
                              .join("/")})`
                          : "(Selecione as datas)"}
                      </p>

                      {isLoading ? (
                        <i
                          className="mdi mdi-spin mdi-loading"
                          style={{ fontSize: "30px" }}
                        ></i>
                      ) : (
                        <div
                          style={{
                            fontSize: "28px",
                            fontWeight: "bold",
                            color: "#333",
                          }}
                        >
                          <span style={{ color: "black" }}>{blackPart}</span>
                          <span style={{ color: "red" }}>{redPart}</span>
                          <span
                            style={{
                              color: "black",
                              marginLeft: "5px",
                            }}
                          >
                            {unit}
                          </span>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>

                <div className="col-md-12 mt-4 text-center">
                  <div className="text-center">
                    {isLoading ? (
                      <i
                        className="mdi mdi-spin mdi-loading"
                        style={{ fontSize: "50px" }}
                      ></i>
                    ) : (
                      <Button
                        color="secondary"
                        className="btn-lg"
                        type="submit"
                        onClick={handleSubmit(onSubmit)}
                      >
                        Pesquisar <i className="dripicons-search" />
                      </Button>
                    )}
                  </div>
                </div>

                {/* Resultado após busca — só com medidor específico */}
                {searchmd.searched && isMedidor && (
                  <div className="col-md-12 mt-4 text-center leitura-atual-wrap">
                    <span>Medidor: {currentMedidor}</span>
                    <br />
                    <span style={{ fontWeight: "600" }}>
                      Leitura Atual
                      <span className="font20">
                        <HiOutlineQuestionMarkCircle
                          onMouseOver={() => setIsShowncd(true)}
                          onMouseOut={() => setIsShowncd(false)}
                        />
                      </span>
                    </span>
                    <br />
                    {isShowncd && (
                      <div className="box-left">
                        <img
                          className="leitura-demo-img"
                          src={relojiodemo}
                          alt="Demonstração do relógio (leitura)"
                        />
                      </div>
                    )}
                    <span style={{ color: "black" }}>{relojio?.pri}</span>
                    <span style={{ color: "black" }}>{relojio?.seg}</span>
                    <span style={{ color: "black" }}>{relojio?.ter}</span>
                    <span style={{ color: "black" }}>{relojio?.qua}</span>
                    <span style={{ color: "red" }}>{relojio?.qui}</span>
                    <span style={{ color: "red" }}>{relojio?.sex}</span>
                    <span style={{ color: "red" }}>{relojio?.set}</span>
                    <span>M³</span>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Container fluid>
          <Row>
            <Col lg={12}>
              {/*<td>
                      {new Date(consumption.DT_RX_TIME).toLocaleDateString()}
                    </td>
                    <td>
                      {new Date(consumption.DT_RX_TIME).toLocaleTimeString()}
                    </td>
                    <td>{consumption.NR_BATERIA}</td>
                    <td>{consumption.NR_BASE_TEMPO}</td>
                    <td>{consumption.NR_PULSO_LITROS}</td>
                    <td>{consumption.NR_VLR_PULSO}</td>
                    <td>{consumption.NR_QUANTIDADE_LITROS}</td>
                    <td>0</td>
                    <td>
                      <span className="badge bg-danger bg-primary">
                        {consumption.NR_ALARME}
                      </span>
                    </td>
                  </tr> */}
            </Col>
            <Col lg={12}>
              {consumptions && consumptions.length > 0 && (
                <Button
                  color="primary"
                  onClick={handleDownload}
                  disabled={isLoading}
                >
                  Baixar Relatório
                </Button>
              )}
            </Col>
          </Row>
          <div className="table-rep-plugin">
            {isLoading ? (
              <div className="text-center mt-5 mb-5">
                <i
                  className="mdi mdi-spin mdi-loading"
                  style={{ fontSize: "50px" }}
                ></i>
              </div>
            ) : (
              <div
                className="table-responsive "
                style={{ maxHeight: "450px" }}
                data-pattern="priority-columns"
              >
                <Table className="table table-striped table-bordered  ">
                  <Thead className="">
                    <Tr>
                      {/* <th className="align-middle">IDA</th> */}
                      {/* <Th className="align-middle ">Modulo</Th> */}
                      <Th
                        className="align-middle"
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "#fff",
                          zIndex: 1,
                        }}
                      >
                        Nr. Medidor
                      </Th>
                      <Th
                        className="align-middle"
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "#fff",
                          zIndex: 1,
                        }}
                      >
                        Imóvel
                      </Th>
                      <Th
                        className="align-middle"
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "#fff",
                          zIndex: 1,
                        }}
                      >
                        Condomínio
                      </Th>
                      {/* <Th className="align-middle">Modelo Medidor</Th> */}
                      {/* <th className="align-middle">Localização</th> */}
                      <Th
                        className="align-middle"
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "#fff",
                          zIndex: 1,
                        }}
                      >
                        Data
                      </Th>
                      <Th
                        className="align-middle"
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "#fff",
                          zIndex: 1,
                        }}
                      >
                        Hora
                      </Th>
                      {/* <Th className="align-middle">Bateria</Th> */}
                      {/* <th className="align-middle">Base Tempo</th>  */}
                      <Th
                        className="align-middle"
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "#fff",
                          zIndex: 1,
                        }}
                      >
                        Litros
                      </Th>
                      <Th
                        className="align-middle"
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "#fff",
                          zIndex: 1,
                        }}
                      >
                        Metro cúbico (m³)
                      </Th>
                      <Th
                        className="align-middle"
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "#fff",
                          zIndex: 1,
                        }}
                      >
                        Leitura Atual
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {/* {console.log(consumptions)} */}
                    {consumptions?.map((consumption, key) => (
                      <Tr
                        onClick={() => {
                          setSelect(key)
                          applyLeituraFromConsumo(consumption)
                        }}
                        key={"_tr_" + key}
                      >
                        {/* <td>{consumption.IDA}</td> */}
                        {/* <Td>{consumption.MODULO_LORA}  </Td> */}
                        <Td>{consumption?.NR_HIDROMETRO_IMOVEL}</Td>
                        <Td>{consumption?.DS_COMPLEMENTO_IMOVEL}</Td>
                        <Td>{consumption?.NM_RAZAO_SOCIAL}</Td>
                        {/* <Td>{consumption?.MODELO_MEDIDOR}</Td> */}
                        {/* <td>{consumption?.DS_LOCALIDADE}</td> */}
                        <Td>
                          {consumption.DT_RX_TIMED ||
                            new Date(consumption.DT_LEITURA).toLocaleDateString(
                              "pt-BR",
                              { timeZone: "America/Sao_Paulo" },
                            )}
                        </Td>
                        <Td>
                          {consumption.DT_RX_TIMEH ||
                            new Date(consumption.DT_LEITURA).toLocaleTimeString(
                              "pt-BR",
                              { timeZone: "America/Sao_Paulo" },
                            )}
                        </Td>
                        {/* <Td>{consumption.DS_BATERIA ? consumption.DS_BATERIA : "0" }  </Td> */}
                        {/* <td>{consumption.NR_BASE_TEMPO}</td>  */}
                        <Td>{getLitrosDaLinha(consumption, usesSyndicConsumptionView).toFixed(2)}</Td>
                        <Td>{getM3DaLinha(consumption, usesSyndicConsumptionView).toFixed(3)}</Td>
                        <Td>
                          {(() => {
                            const val = consumption.NR_LEITURA_ATUAL
                            if (val === undefined || val === null || isNaN(val))
                              return ""
                            const formatted = val.toFixed(0).padStart(7, "0")
                            const black = formatted.slice(0, -3)
                            const red = formatted.slice(-3)
                            return (
                              <span style={{ fontWeight: "bold" }}>
                                <span style={{ color: "black" }}>{black}</span>
                                <span style={{ color: "red" }}>{red}</span>
                              </span>
                            )
                          })()}
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </div>
            )}
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Consumo
